import { tap } from "rxjs/operators";

export const previewBinaryInBrowser = (type: 'image' | 'pdf' = 'image') => {
    return tap((data: any) => {
        const media = URL.createObjectURL(new Blob([data], { type: type === 'pdf' ? 'application/pdf' : 'image/jpg' }))

        window.open(media)

    })
};